import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'Shared/util/custom-hooks';
import { fetchPaymentSummary } from 'Shared/util/web-api';
import { PaymentSummary } from 'Shared/util/types';
import useAppContext from 'Contexts/app-context';
import { formatAmount } from 'Shared/util/formatters';
import Notice from 'Shared/components/notice';
import styles from './notice.css';


const PaymentSummaryNotice = () => {
  const [paymentSummary, setPaymentSummary] = useState<PaymentSummary>();
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { appData } = useAppContext();
  const t = useTranslation(x => x.notices);

  useEffect(() => {
    /* NOTE: React might show an incorrect error ("Warning: Can't perform a React state update on an unmounted component...") if component
    have been unmounted on "setState". This should be fixed in upcoming release https://github.com/facebook/react/pull/22114 */
    fetchPaymentSummary()
      .then((result) => setPaymentSummary(result))
      .finally(() => setLoading(false));
  }, []);

  const handleButtonClick = () => {
    history.push({
      pathname: '/payments',
      state: { fromDate: new Date(new Date().toDateString()) },
    });
  };

  return ((loading || !paymentSummary || paymentSummary.number < 1)
    ? null
    : (
      <Notice
        svgPath="/pile-of-money-small.svg"
        content={
          <>
            {t.format((paymentSummary.number > 1 ? t.invoicesPaid : t.invoicePaid), { numberOf: paymentSummary.number })}
            <span className={styles.largeAmountText}>{formatAmount(paymentSummary.totalAmount)}</span>
            {t.format(t.currencyName, { cultureCurrency: appData.currencyCode })}
          </>
        }
        button={{
          buttonType: 'button-secondary',
          text: t.viewPaidInvoices,
          onClick: handleButtonClick,
        }}
      />
    ));
};

export default PaymentSummaryNotice;
